/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
define([], function () {
	'use strict';

	return {
		getAncestorOfClass: function getAncestorOfClass(node, className) {
			var doc = document;
			while (node && node !== doc) {
				if (node.className.split(' ').indexOf(className) >= 0) {
					return node;
				}
				node = node.parentNode;
			}

			return null;
		},

		isTouchEvent: function isTouchEvent(ev) {
			return ev.type.indexOf('touch') === 0;
		},

		isPointerTouch: function isPointerTouch(ev) {
			return ev.gesture && ev.gesture.pointerType === 'touch';
		},

		isMultiTouchEvent: function isMultiTouchEvent(ev) {
			var oev = ev.originalEvent || ev;
			if (oev && oev.touches && oev.touches.length > 1) {
				return true;
			}
			return false;
		},

		isGesture: function isGesture(ev) {
			if (ev.gesture && ev.gesture.touches && ev.gesture.touches.length > 0) {
				return true;
			}
			return false;
		},

		getEventPos: function getEventPos(ev) {
			var pageValuesValid = function pageValuesValid(event) {
				return event && (event.pageX || event.pageX === 0) && (event.pageY || event.pageY === 0);
			};

			var pos;
			if (this.isGesture(ev)) {
				var touches = ev.gesture.touches[0];
				if (pageValuesValid(touches)) {
					pos = {
						pageX: touches.pageX,
						pageY: touches.pageY
					};
				}
			}
			if (!pos && this.isTouchEvent(ev)) {
				var oev = ev.originalEvent || ev;
				if (oev && oev.touches.length > 0 && pageValuesValid(oev.touches[0])) {
					pos = { pageX: oev.touches[0].pageX, pageY: oev.touches[0].pageY };
				}
			}
			if (!pos && pageValuesValid(ev)) {
				pos = { pageX: ev.pageX, pageY: ev.pageY };
			}
			if (!pos && pageValuesValid(ev.originalEvent)) {
				pos = { pageX: ev.originalEvent.pageX, pageY: ev.originalEvent.pageY };
			}
			if (!pos) {
				// could not find any valid numbers so return zero.  Returning undefined values breaks some other code.
				pos = { pageX: 0, pageY: 0 };
			}
			return pos;
		},

		getEventTarget: function getEventTarget(ev) {
			if (this.isTouchEvent(ev)) {
				var oev = ev.originalEvent || ev;
				if (oev && oev.touches.length > 0) {
					return oev.touches[0].target;
				}
			}
			return ev.target;
		},

		withinElementBoundaries: function withinElementBoundaries(event, node) {
			var pos = this.getEventPos(event);
			var boundingRect = node.getBoundingClientRect();
			var inXRange = pos.pageX >= boundingRect.left && pos.pageX <= boundingRect.right;
			var inYRange = pos.pageY >= boundingRect.top && pos.pageY <= boundingRect.bottom;

			return inXRange && inYRange;
		}

	};
});
//# sourceMappingURL=dom-utils.js.map



// WEBPACK FOOTER //
// ./src/js/lib/@waca/core-client/js/core-client/utils/dom-utils.js